<template>
  <li
    v-if="canViewHorizontalNavMenuHeaderLink(item)"
    class="nav-item text-black"
    :class="{'sidebar-group-active active': isActive}"
  >
    <b-link
      v-if="item.action"
      class="nav-link"
      href="#"
      @click.prevent="handleAction"
    >
      <feather-icon
        v-if="item.icon"
        size="14"
        :icon="item.icon"
      />
      <span>{{ t(item.title) }}</span>
    </b-link>
    <b-link
      v-else
      class="nav-link"
      :to="{ name: item.route }"
    >
      <feather-icon
        v-if="item.icon"
        size="14"
        :icon="item.icon"
      />
      <span>{{ t(item.title) }}</span>
    </b-link>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import useHorizontalNavMenuHeaderLink from './useHorizontalNavMenuHeaderLink'
import mixinHorizontalNavMenuHeaderLink from './mixinHorizontalNavMenuHeaderLink'

export default {
  components: {
    BLink,
  },
  mixins: [mixinHorizontalNavMenuHeaderLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, updateIsActive } = useHorizontalNavMenuHeaderLink(props.item)

    const { t } = useI18nUtils()
    const { canViewHorizontalNavMenuHeaderLink } = useAclUtils()

    const handleAction = () => {
      if (props.item.action === 'softphone') {
        window.open(
          'https://nexus-softphone.tubtimcrm.com',
          'softphone',
          'width=420,height=920,resizable=no,scrollbars=no,toolbar=no,menubar=no,location=no,status=no'
        )
      } else if (props.item.action === 'chat') {
        window.open('https://socialchat.tubtimcrm.com/', '_blank')
      } else if (typeof props.item.action === 'function') {
        props.item.action()
      }
    }

    return {
      isActive,
      updateIsActive,
      handleAction,

      // ACL
      canViewHorizontalNavMenuHeaderLink,

      // i18n
      t,
    }
  },
}
</script>
<style scoped>
.text-black {
  color: black !important;
}
</style>